import React, { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import axios from "axios";

export default function ContactForm() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const [form, setForm] = useState({
    name: "", 
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/contact`, form);
      alert("✅ Message sent!");
      setForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });
    } catch (err) {
      console.error(err);
      alert("❌ Failed to send message.");
    }
  };

  return (
    <div ref={ref} className="relative bg-white flex items-center justify-start">
      <div className="w-full bg-[#0F172B] p-6 md:p-10">
        {/* Top Section */}
        <motion.div
          className="text-left"
          initial={{ x: -100, opacity: 0 }}
          animate={isInView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.div
            className="inline-block bg-[#432DD7] font-[Nunito] text-white px-7 py-3 cursor-pointer rounded-full text-sm font-semibold mb-3 text-xl"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={isInView ? { scale: 1, opacity: 1 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Get In Touch
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-3" style={{ fontFamily: "PT Sans" }}>
            Send Us a Message
          </h2>
          <p style={{ fontFamily: "Allison, sans-serif" }} className="text-white text-3xl md:text-4xl mt-2">
            for quick assistance and expert support anytime.
          </p>
          <p className="text-white mt-4 leading-relaxed text-lg md:text-[16px] font-[Nunito]">
            For quick assistance and expert support anytime, our team is always ready to help. We provide reliable solutions, instant guidance, and professional advice to meet your needs.
          </p>
        </motion.div>

        {/* Form Section */}
        <motion.form
          onSubmit={handleSubmit}
          className="mt-8 w-full font-[Nunito]"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="w-full">
              <label className="text-gray-300 block mb-2">Your Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="John Doe"
                required
                className="w-full bg-transparent border border-white text-white px-4 py-3 rounded-lg focus:outline-none"
              />
            </div>
            <div className="w-full">
              <label className="text-gray-300 block mb-2">Your Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="john@gmail.com"
                required
                className="w-full bg-transparent border border-white text-white px-4 py-3 rounded-lg focus:outline-none"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <div className="w-full">
              <label className="text-gray-300 block mb-2">Phone Number</label>
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="+91 12345 67890"
                className="w-full bg-transparent border border-white text-white px-4 py-3 rounded-lg focus:outline-none"
              />
            </div>
            <div className="w-full">
              <label className="text-gray-300 block mb-2">Subject</label>
              <input
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder="How can we help you?"
                className="w-full bg-transparent border border-white text-white px-4 py-3 rounded-lg focus:outline-none"
              />
            </div>
          </div>

          <div className="mt-6 w-full">
            <label className="text-gray-300 block mb-2">Your Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows="6"
              placeholder="Provide Details"
              className="w-full bg-transparent border border-white text-white px-4 py-3 rounded-lg focus:outline-none resize-none"
            ></textarea>
          </div>

          <div className="mt-6 flex justify-start">
            <button
              type="submit"
              className="bg-[#432DD7] cursor-pointer text-white px-8 py-3 rounded-full font-semibold hover:bg-[#3a25b4] transition w-full md:w-auto"
            >
              Send Message
            </button>
          </div>
        </motion.form>
      </div>
    </div>
  );
}
  